// @ts-nocheck
import React, { createRef } from "react";
import ProcessBaseFn from "../../../commonComponents/processBaseFn";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../sections/taskInfoSections";
import ProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import styles from "../../procedureFileProcess/style/index.module.scss";
import NormalSpin from "../../../../base/basicComponents/spin";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";

const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
export default class BaseApplyJb extends ProcessBaseFn {
  handleReturnProcedureFileSection = () => {
    // this is an empty function
  };

  handleReturnShareTaskSection = () => {
    // this is an empty function
  };

  handleReturnPageName = () => {
    // this is an empty function
  };

  handleConfirmModal = () => {
    // this is an empty function
  };

  handleActionButton = () => {
    // this is an empty function
  };

  handleApplyJbPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.props.pageProps;

    return (
      <PageHeader
        title={this.handleReturnPageName()}
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status={procedureStepStatus}
      />
    );
  };

  handleApplyJbTaskInformationSection = (params: any, isCompletePage: any) => {
    const { taskInfoData } = this.props.sectionProps;
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        testid="task-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            {
              procedureStepId: params.ProcedureStepID,
              procedureTaskId: params.TaskId,
              isHistorical: isCompletePage,
            },
            this.props.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo]
          );
        }}
      />
    );
  };

  handleApplyJbProcedureFileSection = () => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={this.handleReturnProcedureFileSection()}
        testid="procedure-file-block-arrow"
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleApplyJbSupportingFileSection = (params: any, isCompletePage: any) => {
    const { supportingTableData } = this.props;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlySupportingFileSection
            supportingFileRef={supportingFileRef}
            supportingFileTableRef={supportingFileTableRef}
            supportingFileData={supportingTableData}
          />
        }
        testid="supporting-file-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setSupportingFileData,
            this.setError,
            [
              isCompletePage
                ? CompleteStepBusinessType.supportingFile
                : StepBusinessType.supportingFile,
            ],
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.supportingFile.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleApplyJbProcedureInformationSection = (params: any, isCompletePage: any) => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    const pendingTypeList = [
      StepBusinessType.procedureOwner,
      StepBusinessType.pmpExcluded,
      StepBusinessType.primaryProcedureOwner,
    ];

    const completeTypeList = [
      CompleteStepBusinessType.procedureOwner,
      CompleteStepBusinessType.pmpExcluded,
      CompleteStepBusinessType.primaryProcedureOwner,
    ];

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            isShowActions={false}
            noteDisabled={true}
            ppoList={ppoList}
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            submitData={procedureInfoData}
            title="Procedure Information"
          />
        }
        testid="procedure-info-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setProcedureInfoData,
            this.setError,
            isCompletePage ? completeTypeList : pendingTypeList,
            StepService.getMergePayloadBySettingKey([
              CompleteStepBusinessType.procedureOwner.settingKey,
              CompleteStepBusinessType.pmpExcluded.settingKey,
              CompleteStepBusinessType.primaryProcedureOwner.settingKey,
            ])
          );
        }}
      />
    );
  };

  handleApplyJbShareTaskSection = (params: any, isCompletePage: any) => {
    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={this.handleReturnShareTaskSection()}
        testid="share-task-block-arrow"
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            params,
            this.props.setShareTaskData,
            this.setError,
            [StepBusinessType.shareTask],
            StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.shareTask.settingKey])
          );
        }}
      />
    );
  };

  render() {
    const { loading } = this.state;
    const params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };

    const isCompletePage = this.props.pageProps.procedureStepStatus === "Complete";

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        children={
          // @ts-ignore
          <div className={styles.approveNewPro}>
            {this.handleApplyJbPageHeader()}
            {this.handleApplyJbTaskInformationSection(params, isCompletePage)}
            {this.handleApplyJbProcedureFileSection()}
            {this.handleApplyJbSupportingFileSection(params, isCompletePage)}
            {this.handleApplyJbProcedureInformationSection(params, isCompletePage)}
            {this.handleApplyJbShareTaskSection(params, isCompletePage)}
            {/* @ts-ignore */}
            {this.handleActionButton()}
            {/* @ts-ignore */}
            {this.handleConfirmModal()}
          </div>
        }
      />
    );
  }
}
